
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_19372_130707)"}},[_c('path',{attrs:{"d":"M17.639 5.2h-3.01V4.05a.69.69 0 00-.694-.689h-7.87a.69.69 0 00-.695.69V5.2H2.36a.69.69 0 00-.693.689v1.608c0 1.026.65 2.08 1.79 2.893.912.652 2.02 1.065 3.183 1.197.909 1.497 1.971 2.114 1.971 2.114v2.068H7.222c-1.021 0-1.852.595-1.852 1.609v.345c0 .19.156.344.347.344h8.565a.347.347 0 00.348-.345v-.344c0-1.014-.831-1.609-1.852-1.609h-1.39v-2.068s1.063-.617 1.971-2.114c1.166-.132 2.274-.545 3.183-1.197 1.137-.813 1.791-1.867 1.791-2.893V5.89a.69.69 0 00-.694-.69zm-13.1 3.699c-.705-.505-1.02-1.068-1.02-1.402v-.46h1.857c.029.937.168 1.759.37 2.477a4.676 4.676 0 01-1.206-.615zm11.942-1.402c0 .463-.512 1.037-1.021 1.402a4.695 4.695 0 01-1.21.615c.203-.718.342-1.54.37-2.476h1.861v.46z","fill":"#545F7C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_19372_130707"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1.667 3.361)","d":"M0 0h16.667v14.706H0z"}})])])])
          )
        }
      }
    